export default "__VITE_ASSET__df7016da__"